module.exports = __webpack_public_path__ + "img/lingxiu.d4a8f298.png";